export default function brand_details()
{
    return({
        //Company Information
        name: "SBPM",
        subtitle: "Siyanda Bakgatla Platinum Mine",
        sub_entity_name: "Operations Overview",
        sub_entity_subtitle: "Siyanda Platinum",
        
        //Logo Information
        logo:getComputedStyle(document.documentElement)
        .getPropertyValue("--brand-short-logo")
        .replace(/['"]+/g, "")
    });
}
